// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HrResponsibilities_hrGirlImage__nwcbe {
  height: 46rem;
  width: 80%;
  object-fit: cover;
}
@media only screen and (max-width: 767.98px) {
  .HrResponsibilities_hrGirlImage__nwcbe {
    height: 563px;
    width: auto;
  }
}

.HrResponsibilities_sectionHeading__za5Mc {
  color: #548dff;
  font-family: "Roboto";
  font-size: 48px;
  font-style: normal;
  font-weight: 700;
  line-height: 60px;
  width: 440px;
}
@media only screen and (max-width: 767.98px) {
  .HrResponsibilities_sectionHeading__za5Mc {
    font-size: 32px;
    font-style: normal;
    line-height: normal;
    width: 257px;
    margin-left: 10px;
  }
}

.HrResponsibilities_sectionDiscription__hoRdx {
  color: #000;
  font-family: "Roboto";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  width: 546px;
}
@media only screen and (max-width: 767.98px) {
  .HrResponsibilities_sectionDiscription__hoRdx {
    font-size: 15px;
    font-weight: 500;
    line-height: 22px;
    width: 278px;
    margin-left: 10px;
  }
}

/* .colorForSelectedCard{} */
.HrResponsibilities_cardBody__xFJdT {
  width: 296px;
  height: 256px;
  border-radius: 10px;
  background: #ffffff;
  /* background: #ECF2FE; */
  padding: 16px;
}
@media only screen and (max-width: 767.98px) {
  .HrResponsibilities_cardBody__xFJdT {
    margin-left: auto;
    margin-right: auto;
  }
}

.HrResponsibilities_selectedCard__0GMvf {
  background: #ecf2fe;
}

.HrResponsibilities_cardInnerBox__Dyuy1 {
  width: 56px;
  height: 56px;
  border-radius: 8px;
  background: #548dff;
}

.HrResponsibilities_cardInnerHeading__qziZp {
  color: #000;
  font-family: "Roboto";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 26px;
  margin-top: 22px;
}
@media only screen and (max-width: 767.98px) {
  .HrResponsibilities_cardInnerHeading__qziZp {
    font-size: 18px;
    margin-top: 15px;
  }
}

.HrResponsibilities_cardInnerDiscription__Z2k80 {
  color: #8c8c8c;
  font-family: "Roboto";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 118%;
  margin-top: 12px;
}
@media only screen and (max-width: 767.98px) {
  .HrResponsibilities_cardInnerDiscription__Z2k80 {
    font-size: 16px;
    line-height: 18px;
    margin-top: 10px;
  }
}

.HrResponsibilities_learnButtonBoxMannagement__84CCz {
  width: 160px !important;
  height: 56px;
  border-radius: 4px;
  border: 1px solid #5b7cfd;
  padding-bottom: 53px;
  margin-top: 39px;
}

@media only screen and (max-width: 767.98px) {
  .HrResponsibilities_learnButtonBoxMannagement__84CCz {
    width: auto !important;
    height: 40px !important;
    margin-top: 15px;
    border-radius: 4px;
    border: 1px solid #5b7cfd;
    /* margin-right: 10px; */
  }
}

.HrResponsibilities_learnButtonCoustomText__q2hh8 {
  color: #5b7cfd;
  text-align: center;
  font-family: "Roboto";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Homepage/MudasirScreens/HRManagement/components/HrResponsibilities/HrResponsibilities.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;AACnB;AACA;EACE;IACE,aAAa;IACb,WAAW;EACb;AACF;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE;IACE,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA,4BAA4B;AAC5B;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;AACA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":[".hrGirlImage {\n  height: 46rem;\n  width: 80%;\n  object-fit: cover;\n}\n@media only screen and (max-width: 767.98px) {\n  .hrGirlImage {\n    height: 563px;\n    width: auto;\n  }\n}\n\n.sectionHeading {\n  color: #548dff;\n  font-family: \"Roboto\";\n  font-size: 48px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 60px;\n  width: 440px;\n}\n@media only screen and (max-width: 767.98px) {\n  .sectionHeading {\n    font-size: 32px;\n    font-style: normal;\n    line-height: normal;\n    width: 257px;\n    margin-left: 10px;\n  }\n}\n\n.sectionDiscription {\n  color: #000;\n  font-family: \"Roboto\";\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  width: 546px;\n}\n@media only screen and (max-width: 767.98px) {\n  .sectionDiscription {\n    font-size: 15px;\n    font-weight: 500;\n    line-height: 22px;\n    width: 278px;\n    margin-left: 10px;\n  }\n}\n\n/* .colorForSelectedCard{} */\n.cardBody {\n  width: 296px;\n  height: 256px;\n  border-radius: 10px;\n  background: #ffffff;\n  /* background: #ECF2FE; */\n  padding: 16px;\n}\n@media only screen and (max-width: 767.98px) {\n  .cardBody {\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n\n.selectedCard {\n  background: #ecf2fe;\n}\n\n.cardInnerBox {\n  width: 56px;\n  height: 56px;\n  border-radius: 8px;\n  background: #548dff;\n}\n\n.cardInnerHeading {\n  color: #000;\n  font-family: \"Roboto\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 26px;\n  margin-top: 22px;\n}\n@media only screen and (max-width: 767.98px) {\n  .cardInnerHeading {\n    font-size: 18px;\n    margin-top: 15px;\n  }\n}\n\n.cardInnerDiscription {\n  color: #8c8c8c;\n  font-family: \"Roboto\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 118%;\n  margin-top: 12px;\n}\n@media only screen and (max-width: 767.98px) {\n  .cardInnerDiscription {\n    font-size: 16px;\n    line-height: 18px;\n    margin-top: 10px;\n  }\n}\n\n.learnButtonBoxMannagement {\n  width: 160px !important;\n  height: 56px;\n  border-radius: 4px;\n  border: 1px solid #5b7cfd;\n  padding-bottom: 53px;\n  margin-top: 39px;\n}\n\n@media only screen and (max-width: 767.98px) {\n  .learnButtonBoxMannagement {\n    width: auto !important;\n    height: 40px !important;\n    margin-top: 15px;\n    border-radius: 4px;\n    border: 1px solid #5b7cfd;\n    /* margin-right: 10px; */\n  }\n}\n\n.learnButtonCoustomText {\n  color: #5b7cfd;\n  text-align: center;\n  font-family: \"Roboto\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin-top: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hrGirlImage": `HrResponsibilities_hrGirlImage__nwcbe`,
	"sectionHeading": `HrResponsibilities_sectionHeading__za5Mc`,
	"sectionDiscription": `HrResponsibilities_sectionDiscription__hoRdx`,
	"cardBody": `HrResponsibilities_cardBody__xFJdT`,
	"selectedCard": `HrResponsibilities_selectedCard__0GMvf`,
	"cardInnerBox": `HrResponsibilities_cardInnerBox__Dyuy1`,
	"cardInnerHeading": `HrResponsibilities_cardInnerHeading__qziZp`,
	"cardInnerDiscription": `HrResponsibilities_cardInnerDiscription__Z2k80`,
	"learnButtonBoxMannagement": `HrResponsibilities_learnButtonBoxMannagement__84CCz`,
	"learnButtonCoustomText": `HrResponsibilities_learnButtonCoustomText__q2hh8`
};
export default ___CSS_LOADER_EXPORT___;
